import { i18n } from './../../../i18n';
import {
  fakeOptimizeGoal,
  OptimizeGoal,
  VOStatus,
  ShopType,
  OptimizationGoalItem,
  EMEventType,
} from '@tt4b/ttam-enums';

export const installWithInAppEvent = () => ({
  label: i18n.t('adgroup_optimize_install_with_in_app_event'),
  labelInfo: i18n.t('module_optimize_install_with_in_app_event_hint'),
  value: fakeOptimizeGoal.INSTALL_WITH_IN_APP_EVENT,
});

export const optimizeGoalOptions = (): OptimizationGoalItem[] => [
  {
    label: i18n.t('adgroup_optimize_value_optimization'),
    labelInfo: i18n.t('module_optimize_value_optimization_hint'),
    value: OptimizeGoal.VALUE,
  },
  {
    label: i18n.t('adgroup_optimize_in_app_event'),
    labelInfo: i18n.t('adgroup_optimize_in_app_event_info'),
    value: OptimizeGoal.IN_APP_EVENT,
  },
  {
    label: i18n.t('adgroup_optimize_install'),
    labelInfo: i18n.t('adgroup_optimize_install_info'),
    value: OptimizeGoal.INSTALL,
  },
  {
    label: i18n.t('adgroup_optimize_conversion'),
    labelInfo: i18n.t('adgroup_optimize_conversion_info'),
    value: OptimizeGoal.CONVERT,
  },
  {
    label: i18n.t('adgroup_optimize_click'),
    labelInfo: i18n.t('adgroup_optimize_click_info'),
    value: OptimizeGoal.CLICK,
  },
  {
    label: i18n.t('adgroup_optimize_impression'),
    value: OptimizeGoal.SHOW,
  },
  {
    label: i18n.t('adgroup_optimize_lead'),
    value: OptimizeGoal.LEAD,
  },
  {
    label: i18n.t('adgroup_optimize_fans'),
    value: OptimizeGoal.FANS,
  },
  {
    label: i18n.t('adgroup_optimize_web_views'),
    value: OptimizeGoal.WEBVIEWS,
  },
  {
    label: i18n.t('adgroup_optimize_reach'),
    value: OptimizeGoal.REACH,
  },
  {
    label: i18n.t('adgroup_optimize_landing_page_view'),
    labelInfo: i18n.t('adgroup_optimize_landing_page_view_info'),
    value: OptimizeGoal.LANDING_PAGE_VIEW,
  },
  {
    label: i18n.t('adgroup_optimize_destination_visit'),
    labelInfo: i18n.t('adgroup_optimize_destination_visit_info'),
    value: OptimizeGoal.DESTINATION_VISIT,
  },
  {
    label: 'Video View', // 这里一直不会显示，所以就不添加多语言
    value: OptimizeGoal.VIDEO_VIEW,
  },
];

const { CONVERT, CLICK, PRODUCT_CLICK_IN_LIVE, MT_LIVE_ROOM, VALUE } = OptimizeGoal;

// 浅层转化事件
export const ExternalAction = {
  active: 8,
  activeRegister: 13,
  login: 114,
  createGameRole: 38,
  completeTutorial: 131,
  liveClickProduct: 167,
  initiateOrder: 267,
  shopping: 96,
  liveStayTime: 186,
};

// shop live的og列表
export const shopLiveObjectiveOptimizationGoalOptions = () => [
  {
    // value
    label: i18n.t('adgroup_optimize_value_optimization_v2'),
    labelInfo: i18n.t('module_optimize_value_optimization_hint_v2'),
    value: VALUE,
    realValue: VALUE,
    externalAction: ExternalAction.shopping,
  },
  {
    label: i18n.t('module_adgroup_optimize_conversion_purchase'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_purchase_hint'),
    value: fakeOptimizeGoal.COMPLETE_PAYMENT,
    realValue: CONVERT,
    externalAction: ExternalAction.shopping,
    enableShopTypes: [ShopType.ecommShop],
  },
  {
    // Order
    label: i18n.t('module_adgroup_optimize_conversion_order'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_order_hint'),
    value: fakeOptimizeGoal.INITATE_CHECKOUT,
    realValue: CONVERT,
    externalAction: ExternalAction.initiateOrder,
  },
  {
    // product click in live
    label: i18n.t('module_adgroup_optimize_conversion_product_link'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_product_link_hint'),
    value: PRODUCT_CLICK_IN_LIVE,
    realValue: PRODUCT_CLICK_IN_LIVE,
    externalAction: ExternalAction.liveClickProduct,
  },
  {
    // liveStayTime
    label: i18n.t('module_ad_active_stay_time'),
    labelInfo: i18n.t('module_ad_active_stay_time_hint'),
    value: MT_LIVE_ROOM,
    realValue: MT_LIVE_ROOM,
    externalAction: ExternalAction.liveStayTime,
  },
  {
    // Click
    label: i18n.t('adgroup_optimize_click_v2'),
    labelInfo: i18n.t('adgroup_optimize_click_info_v2'),
    value: CLICK,
    realValue: CLICK,
    externalAction: 0,
  },
];

// shop video的og列表
export const shopVideoObjectiveOptimizationGoalOptions = () => [
  {
    // value
    label: i18n.t('adgroup_optimize_value_optimization_v2'),
    labelInfo: i18n.t('module_optimize_value_optimization_hint_v2'),
    value: VALUE,
    realValue: VALUE,
    externalAction: ExternalAction.shopping,
    enableShopTypes: [ShopType.ecommShop, ShopType.tt4bShop],
  },
  {
    // Purchase
    label: i18n.t('module_adgroup_optimize_conversion_purchase'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_purchase_hint'),
    value: fakeOptimizeGoal.COMPLETE_PAYMENT,
    realValue: CONVERT,
    externalAction: ExternalAction.shopping,
    enableShopTypes: [ShopType.ecommShop],
  },
  {
    // Order
    label: i18n.t('module_adgroup_optimize_conversion_order'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_order_hint'),
    value: fakeOptimizeGoal.INITATE_CHECKOUT,
    realValue: CONVERT,
    externalAction: ExternalAction.initiateOrder,
    enableShopTypes: [ShopType.ecommShop, ShopType.tt4bShop],
  },
  {
    // Click
    label: i18n.t('adgroup_optimize_click_v2'),
    labelInfo: i18n.t('adgroup_optimize_click_info_v2'),
    value: CLICK,
    realValue: CLICK,
    externalAction: 0,
    enableShopTypes: [ShopType.ecommShop, ShopType.tt4bShop],
  },
  {
    // Offsite Event
    label: i18n.t('module_adgroup_optimize_conversion_offsite_event'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_offsite_event_hint'),
    value: fakeOptimizeGoal.OFFSITE_EVENT,
    realValue: CONVERT,
    externalAction: 0, // 需要通过 pixel 去选择
    enableShopTypes: [ShopType.tt4bShop],
  },
];

export const showcaseOptimizationGoalOptions = () => [
  {
    // value
    label: i18n.t('adgroup_optimize_value_optimization_v2'),
    labelInfo: i18n.t('module_optimize_value_optimization_hint_v2'),
    value: VALUE,
    realValue: VALUE,
    externalAction: ExternalAction.shopping,
  },
  {
    // Purchase
    label: i18n.t('module_adgroup_optimize_conversion_purchase'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_purchase_hint'),
    value: fakeOptimizeGoal.COMPLETE_PAYMENT,
    realValue: CONVERT,
    externalAction: ExternalAction.shopping,
  },
  {
    // Order
    label: i18n.t('module_adgroup_optimize_conversion_order'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_order_hint'),
    value: fakeOptimizeGoal.INITATE_CHECKOUT,
    realValue: CONVERT,
    externalAction: ExternalAction.initiateOrder,
  },
  {
    // Click
    label: i18n.t('adgroup_optimize_click_v2'),
    labelInfo: i18n.t('adgroup_optimize_click_info_v2'),
    value: CLICK,
    realValue: CLICK,
    externalAction: 0,
  },
];

export const psaOptimizationGoalOptions = () => [
  {
    // GMV
    label: i18n.t('adgroup_optimize_value_optimization_v2'),
    labelInfo: i18n.t('module_optimize_value_optimization_hint_v2'),
    value: VALUE,
    realValue: VALUE,
    externalAction: ExternalAction.shopping,
  },
  {
    // Purchase
    label: i18n.t('module_adgroup_optimize_conversion_purchase'),
    labelInfo: i18n.t('module_adgroup_optimize_conversion_purchase_hint'),
    value: fakeOptimizeGoal.COMPLETE_PAYMENT,
    realValue: CONVERT,
    externalAction: ExternalAction.shopping,
  },
  {
    // Click
    label: i18n.t('adgroup_optimize_click_v2'),
    labelInfo: i18n.t('adgroup_optimize_click_info_v2'),
    value: CLICK,
    realValue: CLICK,
    externalAction: EMEventType.NO_ACTIVE,
  },
];

export const voStatusAppOptions = () => ({
  [VOStatus.INSUFFICIENT_EVENTS]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_insufficient_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_event_insufficient_desc', { eventNum: 30, dayNum: 7 }),
  },
  [VOStatus.NOEVENT]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_app_waiting_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_waiting_desc'),
  },
  [VOStatus.QUALIFIED]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
  [VOStatus.NOVALUE]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_value_require_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_event_value_require_desc'),
  },
  [VOStatus.NOTSUPPORT]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
});

export const voStatusWebsiteOptions = () => ({
  [VOStatus.INSUFFICIENT_EVENTS]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_insufficient_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_event_insufficient_desc', { eventNum: 20, dayNum: 7 }),
  },
  [VOStatus.NOEVENT]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_website_no_event_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_no_event_desc'),
  },
  [VOStatus.NOVALUE]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_value_require_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_event_value_require_desc'),
  },
  [VOStatus.QUALIFIED]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
  [VOStatus.NOTSUPPORT]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_insufficient_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_event_insufficient_desc', { eventNum: 20, dayNum: 7 }),
  },
});
